const readToken = () => {
  try {
    const user = JSON.parse(localStorage.getItem("_bna") || "null");
    return user?.token || "";
  } catch {
    return "";
  }
};

export const authHeader = () => {
  const token = readToken();
  return {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Bearer ${token}`,
  };
};

export const multipartHeader = () => ({
  "x-access-token": readToken(),
});

export default { authHeader, multipartHeader };
